import React from "react";
import "./style.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
function Herosection(props) {
  /*  this is hero section component used in token page  khaled Mofeed | 29/10/2022  */
  return (
    <Row className="justify-content-center" id="home">
      <Col md={10}>
        <Row className="align-items-center min-height-100">
          <Col lg={5} className="hero-content">
            <h1 id="id_h1Telv">
              Building Digital Innovation,
              <br /> Business Growth &amp;
              <br /> Global Supply Solutions
            </h1>

            <p id="id_Lozrian_p">
              Lozrian delivers innovative digital solutions, strategic business
              services, and reliable supply &amp; trading solutions that help
              organizations grow with confidence.
            </p>
          </Col>
          <Col lg={7} className="position-relative overflow-hidden">
            <div className="hero-graphic" id="id_HeroGraphic">
              <svg
                viewBox="0 0 450 490"
                className="hero-graphic-svg"
                role="img"
                aria-label="Lozrian digital, business, and supply solutions"
              >
                <defs>
                  <linearGradient id="heroCardGrad" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#f5f1fc" />
                    <stop offset="100%" stopColor="#d9bdf7" />
                  </linearGradient>
                  <linearGradient
                    id="heroPurpleGrad"
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="1"
                  >
                    <stop offset="0%" stopColor="#b98aef" />
                    <stop offset="100%" stopColor="#9b5de5" />
                  </linearGradient>
                  <linearGradient id="heroPinkGrad" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#f8a7d6" />
                    <stop offset="100%" stopColor="#f15bb5" />
                  </linearGradient>
                  <linearGradient id="heroTealGrad" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#6be9d4" />
                    <stop offset="100%" stopColor="#00e0ba" />
                  </linearGradient>
                  <filter
                    id="heroSoftShadow"
                    x="-50%"
                    y="-50%"
                    width="200%"
                    height="200%"
                  >
                    <feDropShadow
                      dx="0"
                      dy="10"
                      stdDeviation="14"
                      floodColor="#9b5de5"
                      floodOpacity="0.18"
                    />
                  </filter>
                </defs>

                <rect
                  x="70"
                  y="70"
                  width="380"
                  height="380"
                  rx="64"
                  fill="url(#heroCardGrad)"
                  filter="url(#heroSoftShadow)"
                />

                <g
                  stroke="#c9a6f2"
                  strokeWidth="2"
                  strokeDasharray="4 6"
                  opacity="0.6"
                >
                  <line x1="180" y1="180" x2="340" y2="150" />
                  <line x1="180" y1="180" x2="200" y2="340" />
                  <line x1="200" y1="340" x2="340" y2="150" />
                </g>

                {/* Digital Solutions */}
                <g transform="translate(180,180)">
                  <g className="hero-badge hero-badge-digital">
                    <circle
                      r="58"
                      fill="url(#heroPurpleGrad)"
                      filter="url(#heroSoftShadow)"
                    />
                    <polyline
                      points="-18,-14 -30,0 -18,14"
                      fill="none"
                      stroke="#fff"
                      strokeWidth="7"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <polyline
                      points="18,-14 30,0 18,14"
                      fill="none"
                      stroke="#fff"
                      strokeWidth="7"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      x1="6"
                      y1="-18"
                      x2="-6"
                      y2="18"
                      stroke="#fff"
                      strokeWidth="6"
                      strokeLinecap="round"
                    />
                  </g>
                </g>

                {/* Business Solutions */}
                <g transform="translate(200,340)">
                  <g className="hero-badge hero-badge-business">
                    <circle
                      r="54"
                      fill="url(#heroPinkGrad)"
                      filter="url(#heroSoftShadow)"
                    />
                    <rect
                      x="-24"
                      y="6"
                      width="12"
                      height="20"
                      rx="3"
                      fill="#fff"
                    />
                    <rect
                      x="-6"
                      y="-6"
                      width="12"
                      height="32"
                      rx="3"
                      fill="#fff"
                    />
                    <rect
                      x="12"
                      y="-18"
                      width="12"
                      height="44"
                      rx="3"
                      fill="#fff"
                    />
                  </g>
                </g>

                {/* Supply & Trading Solutions */}
                <g transform="translate(340,150)">
                  <g className="hero-badge hero-badge-supply">
                    <circle
                      r="50"
                      fill="url(#heroTealGrad)"
                      filter="url(#heroSoftShadow)"
                    />
                    <circle r="24" fill="none" stroke="#fff" strokeWidth="5" />
                    <ellipse
                      rx="9"
                      ry="24"
                      fill="none"
                      stroke="#fff"
                      strokeWidth="5"
                    />
                    <line
                      x1="-24"
                      y1="0"
                      x2="24"
                      y2="0"
                      stroke="#fff"
                      strokeWidth="5"
                    />
                  </g>
                </g>

                <circle
                  className="hero-accent hero-accent-dot"
                  cx="410"
                  cy="330"
                  r="10"
                  fill="#fee440"
                />
                <path
                  className="hero-accent hero-accent-spark"
                  d="M100,330 l6,16 l16,6 l-16,6 l-6,16 l-6,-16 l-16,-6 l16,-6 z"
                  fill="#f15bb5"
                />
              </svg>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Herosection;
